import type { RouteObject } from "src/router";
import { lazyNamed } from "src/utils/lazy-named";

import { AdminToolsLayout } from "./layout";

const AdminTools = lazyNamed(() => import("./index"), "AdminTools");
const GeminiAuth = lazyNamed(() => import("./gemini-auth"), "GeminiAuth");

export const routes: RouteObject[] = [
  {
    path: "admin-tools",
    element: <AdminToolsLayout />,
    spacesAccess: "hidden-from-limited-view",
    children: [
      {
        index: true,
        element: <AdminTools />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "gemini-auth",
        element: <GeminiAuth />,
        spacesAccess: "hidden-from-limited-view",
      },
    ],
  },
];
